import { useState } from "react";
import { API_URL } from "../../APIService";

function FormImage(props: any) {
  const { alt, id, imgTitle, name, onChange, title, readOnly } = props;
  const [src, setSrc] = useState(props.src);
  const onDelete = () => {
    if (props.onDelete()) setSrc("");
  };

  return (
    <div className="EditForm">
      <label className="EditLabel">{title}</label>
      <div className="EditInputHolder">
        {!readOnly ? (
          <input type="file" name={name} onChange={onChange} id={id}></input>
        ) : (
          <></>
        )}
        <div>
          {src}
          {src && src.length > 0 && !readOnly ? (
            <span style={{ paddingLeft: "10px" }}>
              <button onClick={onDelete}>delete</button>
            </span>
          ) : (
            <></>
          )}
        </div>

        {src.toString().length > 0 ? (
          <img src={API_URL + "image" + src} alt={alt} title={imgTitle} />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default FormImage;
